import { render, staticRenderFns } from "./inboxInput.vue?vue&type=template&id=00a9c58c&scoped=true&"
import script from "./inboxInput.vue?vue&type=script&lang=js&"
export * from "./inboxInput.vue?vue&type=script&lang=js&"
import style0 from "./inboxInput.vue?vue&type=style&index=0&id=00a9c58c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a9c58c",
  null
  
)

export default component.exports